import DesignSelect from '../../../../components/select/DesignSelect';
import useAgenciesDataStore from '../../../../core/hooks/useAgenciesDataStore';
import { ChangeHandler } from '../../types';

export interface OohAgencySelectProps {
  agencyChangeHandler: ChangeHandler;
  agencyInputValue: string | null;
}

const OohAgencySelect = ({
  agencyChangeHandler,
  agencyInputValue,
}: OohAgencySelectProps) => {
  const { agenciesData, areAgenciesLoading } = useAgenciesDataStore();

  const agenciesOptions = agenciesData?.map((agency) => ({
    value: agency.id,
    label: agency.name,
  }));
  return (
    <div className="flex w-full flex-col">
      <label htmlFor="statisticsAgency">Agency</label>
      <DesignSelect
        loading={areAgenciesLoading}
        options={agenciesOptions}
        onChange={agencyChangeHandler}
        value={agenciesOptions.filter((x) => x.value === agencyInputValue)}
      />
    </div>
  );
};

export default OohAgencySelect;
